export var ANALYTIC_KEYS = {
  HomeTariffChangeStart: 'HomeTariffChangeStart'
};
export var PAGE_TYPE = {
  fttb_net: 'fttb-net',
  fttb_kit: 'fttb-kit',
  fttb_yandex: 'fttb-yandex'
};
export var SERVICE_TYPES = {
  equipment: 'equipment',
  services: 'services'
};